import { FC, ReactNode } from 'react';
import { WbBadge } from '../WbBadge';
import { TaskAltIcon } from '../../icons/TaskAlt';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';

type WbEnabledBadgeProps = {
  enabled: boolean;
  renderLabel?: (enabled: boolean) => ReactNode;
};

export const WbEnabledBadge: FC<WbEnabledBadgeProps> = ({
  enabled,
  renderLabel,
}) => {
  let label: ReactNode = enabled ? 'Enabled' : 'Disabled';

  if (renderLabel) {
    label = renderLabel(enabled);
  }

  return (
    <WbBadge
      variant={enabled ? 'stroke' : 'disabled'}
      color={enabled ? 'success' : undefined}
      startIcon={
        enabled ? (
          <TaskAltIcon fontSize="small" />
        ) : (
          <HighlightOffOutlinedIcon fontSize="small" />
        )
      }
    >
      {label}
    </WbBadge>
  );
};
